import IMapBiuraServiceConfig from '~/components/map/types/IMapBiuraServiceConfig';

import IMapEventListenerParams from '../../../types/IMapEventListenerParams';
import buildMarkerBounds from '../../shared/buildMarkerBounds';
import fitBounds from '../../shared/fitBounds';
import getMarkerPosition from '../marker/getMarkerPosition';

const getBoundsArr = (serviceConfig: IMapBiuraServiceConfig): google.maps.LatLngBounds => {
  const { markersInnerState } = serviceConfig;

  return buildMarkerBounds(markersInnerState.markers ? markersInnerState.markers.map((x) => getMarkerPosition(x)) : []);
};

const addEventListenerToMapFullyLoaded = (params: IMapEventListenerParams<IMapBiuraServiceConfig>) => {
  const { serviceConfig, gmap } = params;
  const { mapRef, config } = serviceConfig;

  google.maps.event.addDomListenerOnce(gmap, 'tilesloaded', () => {
    fitBounds({
      mapRef,
      bounds: getBoundsArr(serviceConfig),
      padding: {
        top: 112,
        left: 31.5,
        right: 71.5,
        bottom: 0,
      },
      gmap,
      idleCallback: () => {
        config.isFullyLoaded = true;
      },
    });
  });
};
export default addEventListenerToMapFullyLoaded;
